import { createAction } from "redux-act";

const ADD_OWNER = "ADD_OWNER_DATA";
const ADD_OWNER_FAILED = "ADD_OWNER_FAILED";
const ADD_OWNER_SUCCESS = "ADD_OWNER_SUCCESS";

export const addOwner = createAction(ADD_OWNER);
export const addOwnerFailed = createAction(ADD_OWNER_FAILED);
export const addOwnerSuccess = createAction(ADD_OWNER_SUCCESS);
